/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Reconciliation status for this payee. Defaults to "manual" (displayed as 手動で送信する / Send manually) when no setting has been configured for this payee yet.

 */
export type ApPayeeReconciliationSettingForPayeeStatus =
  (typeof ApPayeeReconciliationSettingForPayeeStatus)[keyof typeof ApPayeeReconciliationSettingForPayeeStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApPayeeReconciliationSettingForPayeeStatus = {
  manual: 'manual',
  not_send: 'not_send',
  auto_send: 'auto_send',
} as const;
